(function () {
  'use strict';

  var MAX_PREFETCHES = 3;
  var prefetched = new Set();
  var progressTimer;
  var progressElement;

  function isOrdinaryInternalLink(link) {
    if (!link || !link.href || link.target && link.target !== '_self' || link.hasAttribute('download')) return false;
    if (link.origin !== window.location.origin || link.protocol !== window.location.protocol) return false;
    if (/^(mailto:|tel:|javascript:)/i.test(link.protocol)) return false;
    if (/^\/(checkout|cart|account)(\/|$)/i.test(link.pathname)) return false;
    if (link.pathname === window.location.pathname && link.search === window.location.search && link.hash) return false;
    return true;
  }

  function isPrefetchCandidate(link) {
    return isOrdinaryInternalLink(link) && /^\/(collections|products)(\/|$)/i.test(link.pathname);
  }

  function clearProgress() {
    document.documentElement.removeAttribute('data-scc-navigation-pending');
    window.clearTimeout(progressTimer);
  }

  function startProgress() {
    if (!progressElement) {
      progressElement = document.createElement('div');
      progressElement.id = 'scc-navigation-progress';
      document.body.appendChild(progressElement);
    }
    document.documentElement.setAttribute('data-scc-navigation-pending', '');
    window.clearTimeout(progressTimer);
    progressTimer = window.setTimeout(clearProgress, 4000);
  }

  function prefetch(link) {
    if (!isPrefetchCandidate(link) || prefetched.size >= MAX_PREFETCHES || prefetched.has(link.href)) return;
    var connection = navigator.connection;
    if (navigator.saveData || connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''))) return;
    prefetched.add(link.href);
    var hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.href = link.href;
    document.head.appendChild(hint);
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest('a[href]');
    if (isOrdinaryInternalLink(link)) startProgress();
  });

  ['pointerover', 'focusin', 'touchstart'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      prefetch(link);
    }, { capture: true, passive: true });
  });

  window.addEventListener('pageshow', clearProgress);
  window.addEventListener('pagehide', function () { window.clearTimeout(progressTimer); });
})();
